var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconePerfil2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_355_7032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1054 7.24512C15.105 7.24512 16.7318 8.87186 16.7318 10.8715C16.7318 12.8712 15.105 14.498 13.1054 14.498C11.1057 14.498 9.48096 12.8712 9.48096 10.8715C9.48096 8.87186 11.1077 7.24512 13.1054 7.24512Z",
    fill: "#ff66c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1054 14.498C15.105 14.498 16.7318 12.8712 16.7318 10.8715C16.7318 8.87186 15.105 7.24512 13.1054 7.24512C11.1057 7.24512 9.48096 8.87186 9.48096 10.8715C9.48096 12.8712 11.1077 14.498 13.1054 14.498Z",
    fill: "#ff66c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1074 0.75C6.35249 0.75 0.857422 6.24506 0.857422 13C0.857422 19.7549 6.35249 25.25 13.1074 25.25C19.8624 25.25 25.3574 19.7549 25.3574 13C25.3574 6.24506 19.8624 0.75 13.1074 0.75ZM20.326 21.0289C20.328 16.2212 20.2716 15.7112 13.3211 15.5641L12.4765 15.556C11.3496 15.556 10.4304 15.6004 9.67855 15.7072C9.36207 15.7516 9.07381 15.808 8.81377 15.8786C8.48117 15.9673 8.19291 16.0801 7.94295 16.2172C6.55407 16.9731 6.35249 18.5072 6.35047 21.424C3.88515 19.4425 2.30275 16.4047 2.30275 13.004C2.30476 7.04332 7.15074 2.19734 13.1074 2.19734C19.0641 2.19734 23.9101 7.04332 23.9101 13C23.9101 16.185 22.5252 19.0494 20.326 21.0289Z",
    fill: "#ff66c4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_355_7032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 24.5,
    fill: "white",
    transform: "translate(0.857422 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePerfil2);
export default __webpack_public_path__ + "static/media/IconePerfil2.3560c740eca5815f68f390cfb6d2154f.svg";
export { ForwardRef as ReactComponent };